<template>
  <div class="data_table_container">
    <div class="data-table-wrapper" v-if="currentTable">
      <!-- 多表格选择 -->
      <div v-if="isMultiTable" style="margin-bottom: 15px;width: 200px;">
        <el-select v-model="selectedTable" placeholder="请选择" @change="handleTableChange">
          <el-option v-for="(value, key) in tableData" :key="key" :label="key" :value="key" />
        </el-select>
      </div>

      <!-- 表格容器，给定固定高度 -->
      <div style="height: 500px;">
        <el-auto-resizer>
          <template #default="{ height, width }">
            <el-table-v2 :columns="v2Columns" :data="paginatedData" :width="width" :height="height" fixed />
          </template>
        </el-auto-resizer>
      </div>
      <!-- 分页 -->
      <div style="text-align: right; margin-top: 10px;">
        <div style="display: inline-block;">
          <el-pagination v-if="currentTable && currentTable.data && currentTable.data.length > pageSize"
            layout="prev, pager, next" :current-page="currentPage" :page-size="pageSize"
            :total="currentTable.data.length" @current-change="handlePageChange" />
        </div>
      </div>

    </div>
    <div v-else>
      <el-divider>暂无数据...</el-divider>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, computed, defineProps, watch, onMounted, onBeforeUnmount } from "vue";
  import PubSub from "pubsub-js";

  import VirtualTable from "./VirtualTable.vue";

  const props = defineProps(["data", "task_result", "file_data"]);

  const tableData = ref(null);       // 多表格时的全部表格
  const isMultiTable = ref(false);   // 是否多表格
  const selectedTable = ref(null);   // 当前选中的表格 key
  const currentTable = ref(null);    // 当前表格

  const currentPage = ref(1);
  const pageSize = ref(10);
  const raw_data = ref(null);
  const node_data_token = ref(null);

  // 分页数据
  const paginatedData = computed(() => {
    if (currentTable.value && currentTable.value.data) {
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value;
      return currentTable.value.data.slice(start, end);
    }
    return [];
  });

  const colWidthCache = reactive({});
  const charWidth = 16; // 每个字符宽度，可根据字体微调
  function calcColWidth(table) {
    console.log("传进来的表格是", table);
    if (!table) return;
    const columns = table.columns;
    const data = table.data;
    if (colWidthCache[table.name]) return; // 已缓存直接返回
    const widths = {};
    columns.forEach((col, colIndex) => {
      let maxLength = col.length;
      data.forEach(row => {
        const cellLength = String(row[colIndex] ?? '').length;
        if (cellLength > maxLength) maxLength = cellLength;
      });
      widths[colIndex] = Math.max(maxLength * charWidth, 150);
    });
    colWidthCache[table.name] = widths;
  };

  const v2Columns = computed(() => {
    if (!currentTable.value) return [];
    const widths = colWidthCache[currentTable.value.name] || {};
    return currentTable.value.columns.map((col, colIndex) => ({
      key: String(colIndex),
      dataKey: String(colIndex),
      title: col,
      width: widths[colIndex] || 150,
      minWidth: 80,
      align: 'left',
      flexGrow: 1,
    }));
  });


  const initTableData = () => {
    if (raw_data.value?.process_report?.length > 0) {
      const defaultVal = raw_data.value.process_report[0].default_val;
      if (defaultVal) {
        if (defaultVal.columns && defaultVal.data) {
          // 单表格
          isMultiTable.value = false;
          currentTable.value = defaultVal;
        } else {
          // 多表格
          isMultiTable.value = true;
          tableData.value = defaultVal;
          selectedTable.value = Object.keys(defaultVal)[0];
          currentTable.value = defaultVal[selectedTable.value];
        }
        // 根据数据动态计算列宽
        calcColWidth(currentTable.value);
        currentPage.value = 1;
      }
    }
  };

  // 切换表格
  const handleTableChange = () => {
    currentTable.value = tableData.value[selectedTable.value];
    currentPage.value = 1;
  };

  const handlePageChange = (newPage) => {
    currentPage.value = newPage;
  };

  // 监听外部 task_result
  watch(() => props.task_result, (newData) => {
    console.log(typeof newData);
    console.log("监听到外部 task_result", newData);
    let title = props.data.title;
    let node_result = newData[title];
    if (node_result && node_result) {
      raw_data.value.process_report[0].default_val = node_result.data;
      currentPage.value = 1;
      initTableData();
    }
  }
  );

  // 生命周期
  onMounted(() => {
    raw_data.value = props.data;
    if (props.data) {
      initTableData();
      node_data_token.value = PubSub.subscribe(props.data.title, (msg, data) => {
        raw_data.value.process_report[0].default_val = data.result.data;
        currentPage.value = 1;
        initTableData();
      });
    } else if (props.file_data) {
      currentTable.value = props.file_data.data;
    }
  });

  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
  });
</script>
<style lang="scss" scoped>
  .data_table_container {
    :deep(.el-table-v2__header-cell) {
      /* background-color: #fafafa; */
      color: #333;
      font-size: 16px;
      background-color: transparent;
    }

    /*   :deep(.el-table-v2__row-cell) {
      color: #757d8a;
      font-size: 14px;
    } */

    :deep(.el-table-v2__header-row) {
      background-color: #FAFAFA;
      border-radius: 8px;
    }

    :deep(.el-virtual-scrollbar.el-vl__horizontal) {
      height: 10px !important;
    }

    :deep(.el-virtual-scrollbar.el-vl__vertical) {
      width: 10px !important;
    }
  }
</style>